module.exports = __webpack_public_path__ + "static/media/close-orange-symbol.af033697.svg";